import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import IconsProfileCartBlock from "../features/User/IconsProfileCartBlock";

const AppIconsProfileCart: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="*" element={<IconsProfileCartBlock />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AppIconsProfileCart;
